import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

type SidebarWrapperProps = {
  isMenuOpen?: boolean;
};

export const SidebarWrapper = styled(Box)<SidebarWrapperProps>(
  ({ theme, isMenuOpen }) => ({
    width: theme.spacing(33.5),
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    '@supports (height: 100dvh)': {
      height: '100dvh',
    },
    flexShrink: 0,
    zIndex: 10,
    boxSizing: 'border-box',
    padding: theme.spacing(9.5, 3, 3),
    backgroundColor: theme.palette.neutral['100'],
    // overflowY: 'auto',

    display: 'flex',
    flexDirection: 'column',
    minHeight: 0, // ✅ важн

    transition: '.3s transform',
    transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)',

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
      transform: 'translateX(0)',
      position: 'sticky',
    },
  })
);
